import React from "react";

/**
 * BlobShape — forme organique en haricot posée en arrière-plan.
 * Utilisée derrière les titres et les grilles de cartes pour donner du mouvement.
 *
 * Props :
 * - variant : "primary" | "soft" | "tint" (couleur du blob)
 * - size : "sm" | "md" | "lg" | "xl"
 * - position : classes Tailwind pour absolute (ex "top-10 -left-20")
 * - animation : "float" | "breathe" | "drift" | null
 * - opacity : nombre entre 0 et 1 (défaut 0.35)
 */
export function BlobShape({
  variant = "primary",
  size = "lg",
  position = "top-0 left-0",
  animation = "float",
  opacity = 0.35,
  className = "",
}) {
  const fillByVariant = {
    primary: "#00C6CE",
    soft: "#66EAF0",
    tint: "#EEF6F8",
  };
  const sizePx = {
    sm: 180,
    md: 280,
    lg: 420,
    xl: 620,
  };
  const dim = sizePx[size] ?? 420;
  const animClass = animation ? `animate-${animation}` : "";

  return (
    <div
      aria-hidden="true"
      className={`absolute pointer-events-none ${position} ${animClass} ${className}`}
      style={{ width: dim, height: dim, opacity, filter: "blur(2px)", zIndex: 0 }}
    >
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <path
          fill={fillByVariant[variant] || fillByVariant.primary}
          d="M45.4,-64.2C57.9,-56.6,66.1,-42.3,71.1,-27.1C76.2,-11.9,78,4.2,73.9,18.7C69.9,33.1,60,45.9,47.5,55.6C35,65.3,20,71.9,3.6,67.1C-12.8,62.3,-30.4,46.1,-42.6,29.4C-54.8,12.6,-61.5,-4.7,-59.6,-21.9C-57.7,-39.1,-47.2,-56.2,-32.9,-64.3C-18.6,-72.4,-0.6,-71.6,15.2,-67.6C31,-63.6,44.6,-56.4,45.4,-64.2Z"
          transform="translate(100 100)"
        />
      </svg>
    </div>
  );
}
